import { create } from 'zustand';
import type { Decisions } from '../types/experimentation';

interface FlagsState {
  decisions: Decisions | null;
  setDecisions: (decisions: Decisions) => void;
  eppoDecisions: Decisions | null;
  eppoSettled: boolean;
  eppoKey: string | null;
  eppoRequestId: number;
  startEppoLookup: (key: string) => number | null;
  setEppoDecisions: (requestId: number, decisions: Decisions | null) => void;
}

export const useFlagsStore = create<FlagsState>((set, get) => ({
  decisions: null,
  setDecisions: (decisions: Decisions) => set({ decisions }),
  eppoDecisions: null,
  eppoSettled: false,
  eppoKey: null,
  eppoRequestId: 0,
  startEppoLookup: (key: string) => {
    const state = get();
    if (state.eppoKey === key) return null;
    const requestId = state.eppoRequestId + 1;
    set({ eppoRequestId: requestId, eppoKey: key, eppoSettled: false, eppoDecisions: null });
    return requestId;
  },
  setEppoDecisions: (requestId: number, decisions: Decisions | null) =>
    set((state) =>
      state.eppoRequestId === requestId ? { eppoDecisions: decisions, eppoSettled: true } : {},
    ),
}));
